import { FormEvent, useEffect } from "react";
import { useSelector } from "react-redux";
import { useBooleanState } from "../../HighlyReusableComponents/hooks/useBooleanState";
import { BarcodeInputField } from "../StagingBuilder/BarcodeInputField";
import { useBinningContext } from "./useBinNumber";

interface Props {
  barcodeRef: React.RefObject<HTMLInputElement>;
}

export const ScannerForm = ({ barcodeRef }: Props) => {
  const { newBarcodeScan } = useBinningContext();
  const socket = useSelector((state: Istate) => state.data.socket);
  const pricingControl = () => {};
  useEffect(() => {
    socket?.off("INVENTORY", pricingControl);
    socket?.on("INVENTORY", pricingControl);
    return () => {
      socket?.off("INVENTORY", pricingControl);
    };
  }, [socket]);

  const initialValues = {
    auto: true,
    stickerTag: false,
    normalTag: false,
    queueNormalTag: false,
    newWindowNormalTag: false,
    newTabNormalTag: false,
  };
  const checkState = useBooleanState(initialValues);

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (
      barcodeRef.current?.value === undefined ||
      barcodeRef.current?.value === ""
    )
      return;
    // need to check if it exists
    // if it does push new info, maybe use modal?
    newBarcodeScan && newBarcodeScan(barcodeRef.current.value);
    // reset the input field
    barcodeRef.current.value = "";
  };
  return (
    <form onSubmit={onSubmit}>
      <BarcodeInputField barcodeRef={barcodeRef} />
      <button style={{ display: "none" }} type="submit"></button>
    </form>
  );
};
